import { Chapter } from "./online-book/Chapter";
import { TopBar } from "./online-book/TopBar";
import { createRoot } from "@wordpress/element";
import registerStore from "./store";
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import rtlPlugin from 'stylis-plugin-rtl';
import { prefixer } from 'stylis';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import { get } from "lodash";
import { Verse } from "./online-book/Verse";
import { Book } from "./online-book/Book";
import { select } from "@wordpress/data";
import { STORE_NAME } from "./store";

registerStore({
	initialState:{
		book: {
			title: get(window, "bbtIsraelBookPageData.bookTitle", ''),
			slug: get(window, "bbtIsraelBookPageData.bookSlug", ''),
			permalink: get(window, "bbtIsraelBookPageData.bookPermalink", ''),
			description: get(window, "bbtIsraelBookPageData.bookData.description", ''),
			chapters: get(window, "bbtIsraelBookPageData.chapters", []),
			verses: get(window, "bbtIsraelBookPageData.verses", []),
			product: get(window, "bbtIsraelBookPageData.product", {
				image: "",
				price: "",
				title: "",
				link: "",
				content: "",
				author: "",
				translator: "",
			}),
			pageType: get(window, "bbtIsraelBookPageData.pageType", ''),
		}
	}
});

const theme = createTheme({ direction: 'rtl' });
  
const cacheRtl = createCache({
	key: 'muirtl',
	stylisPlugins: [prefixer, rtlPlugin],
});

const App = () => {
	const verses = select( STORE_NAME ).getVerses();
	const currentVerse = verses.find(verse => verse.current);
	const chapters = select( STORE_NAME ).getChapters();
	const currentChapter = chapters.find(chapter => chapter.current);
	const pageType = select( STORE_NAME ).getPageType();

	return <CacheProvider value={cacheRtl}>
		<ThemeProvider theme={theme}>
			{ pageType !== 'book' && <TopBar /> }
			{currentVerse && <Verse {...currentVerse} /> }
			{ ! currentVerse && currentChapter && <Chapter /> }
			{ ! currentVerse && ! currentChapter && <Book /> }	
		</ThemeProvider>
	</CacheProvider>;
};

const domNode = document.getElementById("content-area");
const root = createRoot(domNode);
root.render(<App />);
